import { NetworkActionPrefix, PeriodType } from '../utils/constants';
import {
    PerformanceIndicatorApi, PerformanceIndicatorCollectionTypeApi, PerformanceIndicatorComparisonCalculationApi, PerformanceIndicatorComparisonTargetApi,
    PerformanceIndicatorDateRangeApi, PerformanceIndicatorDayDataApi, PerformanceIndicatorDimensionApi, PerformanceIndicatorFormulaApi,
    PerformanceIndicatorFormulaElementTypeApi, PerformanceIndicatorMonthDataApi, PerformanceIndicatorPeriodTypeApi,
    PerformanceIndicatorPointCalculationApi, PerformanceIndicatorQuarterDataApi, PerformanceIndicatorRelativePeriodApi, PerformanceIndicatorValueDependencyRuleApi,
    PerformanceIndicatorValueSourceApi, PerformanceIndicatorWeekDataApi, PerformanceIndicatorYearDataApi, PerformancePerspectiveApi, PerformancePerspectiveGroupApi
} from 'for-straction-service-api';
import { entityLifecycleActionSet, networkAPIAction } from '../utils/actionCreatorsFactory';
import { assertNever } from 'typed/utils';

// TODO merge to typed/actions/indicators

export const loadAllPerformancePerspectives = () =>
    networkAPIAction(PerformancePerspectiveApi, 'performancePerspectiveLoadAllGet', NetworkActionPrefix.LOAD_ALL_PERFORMANCE_PERSPECTIVES_PREFIX);

export const loadAllPerformancePerspectiveGroups = () =>
    networkAPIAction(PerformancePerspectiveGroupApi, 'performancePerspectiveGroupLoadAllGet', NetworkActionPrefix.LOAD_ALL_PERFORMANCE_PERSPECTIVE_GROUPS_PREFIX);

export const loadPerformanceIndicatorPeriodTypes = () =>
    networkAPIAction(PerformanceIndicatorPeriodTypeApi, 'performanceIndicatorPeriodTypeLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_PERIOD_TYPE_PREFIX);

export const loadPerformanceIndicatorDimensions = () =>
    networkAPIAction(PerformanceIndicatorDimensionApi, 'performanceIndicatorDimensionLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_DIMENSIONS_PREFIX);

export const loadPerformanceIndicatorDateRanges = () =>
    networkAPIAction(PerformanceIndicatorDateRangeApi, 'performanceIndicatorDateRangeLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_DATE_RANGES_PREFIX);

export const loadPerformanceIndicatorPointCalculations = () =>
    networkAPIAction(PerformanceIndicatorPointCalculationApi, 'performanceIndicatorPointCalculationLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_POINT_CALCULATIONS_PREFIX);

export const loadPerformanceIndicatorComparisonTargets = () =>
    networkAPIAction(PerformanceIndicatorComparisonTargetApi, 'performanceIndicatorComparisonTargetLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_COMPARISON_TARGETS_PREFIX);

export const loadPerformanceIndicatorComparisonCalculations = () =>
    networkAPIAction(PerformanceIndicatorComparisonCalculationApi, 'performanceIndicatorComparisonCalculationLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_COMPARISON_CALCULATIONS_PREFIX);

export const loadPerformanceIndicatorValueSources = () =>
    networkAPIAction(PerformanceIndicatorValueSourceApi, 'performanceIndicatorValueSourceLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_VALUE_SOURCES_PREFIX);

export const loadPerformanceIndicatorRelativePeriods = () =>
    networkAPIAction(PerformanceIndicatorRelativePeriodApi, 'performanceIndicatorRelativePeriodLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_RELATIVE_PERIOD_PREFIX);

export const loadPerformanceIndicatorCollectionTypes = () =>
    networkAPIAction(PerformanceIndicatorCollectionTypeApi, 'performanceIndicatorCollectionTypeLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_COLLECTION_TYPE_PREFIX);

export const loadPerformanceIndicatorValueDependencyRules = () =>
    networkAPIAction(PerformanceIndicatorValueDependencyRuleApi, 'performanceIndicatorValueDependencyRuleLoadAllGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_VALUE_DEPENDENCY_RULE_PREFIX);

const performanceIndicatorActionSet = entityLifecycleActionSet('PerformanceIndicator', 'PERFORMANCE_INDICATOR', 'indicator', PerformanceIndicatorApi, {
    loadAll: 'performanceIndicatorLoadAllGet',
    add: 'performanceIndicatorAddPut',
    edit: 'performanceIndicatorEditPut',
    delete: 'performanceIndicatorDeleteGet',
    voidAll: true
}, true);
export const loadAllPerformanceIndicators = () => performanceIndicatorActionSet.loadAllPerformanceIndicators();
export const addPerformanceIndicator = (indicator, sync) => performanceIndicatorActionSet.addPerformanceIndicator(indicator, sync);
export const deletePerformanceIndicator = indicatorID => performanceIndicatorActionSet.removePerformanceIndicator(indicatorID);
export const editPerformanceIndicator = (indicator, sync) => performanceIndicatorActionSet.editPerformanceIndicator(indicator, sync);
export const voidAllPerformanceIndicators = (immediately = true) => performanceIndicatorActionSet.voidAllPerformanceIndicators(immediately);

export const testIndicatorFinancialFormula = (indicatorID, formula) =>
    networkAPIAction(
        PerformanceIndicatorApi,
        'performanceIndicatorTestIndicatorFinancialFormulaGet',
        NetworkActionPrefix.TEST_PERFORMANCE_INDICATOR_FORMULA_PREFIX,
        { indicatorID, formula },
        formula
    );

export const addFinancialIndicatorBeforeAnotherIndicator = (indicator, baseIndicatorID) =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorAddBeforeIndicatorPut', NetworkActionPrefix.ADD_FINANCIAL_INDICATOR_BEFORE_ANOTHER_INDICATOR_PREFIX, { indicator, baseIndicatorID }, indicator, baseIndicatorID);

export const addFinancialIndicatorAfterAnotherIndicator = (indicator, baseIndicatorID) =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorAddAfterIndicatorPut', NetworkActionPrefix.ADD_FINANCIAL_INDICATOR_AFTER_ANOTHER_INDICATOR_PREFIX, { indicator, baseIndicatorID }, indicator, baseIndicatorID);

export const addFinancialIndicator = indicator =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorAddFinancialIndicatorPut', NetworkActionPrefix.ADD_FINANCIAL_INDICATOR_PREFIX, { indicator }, indicator);

export const splitFinancialIndicatorToSubAccounts = (sourceIndicators, parentIndicatorID, calculateFinancialData) =>
    networkAPIAction(
        PerformanceIndicatorApi,
        'performanceIndicatorSplitFinancialIndicatorToSubAccountsPut',
        NetworkActionPrefix.SPLIT_FINANCIAL_INDICATOR_TO_SUB_ACCOUNTS_PREFIX,
        { sourceIndicators, parentIndicatorID, calculateFinancialData },
        sourceIndicators,
        parentIndicatorID,
        calculateFinancialData
    );

export const mergeAllPerformanceIndicatorDayData = (entities, rollOverLevels = false, { aggregationLevelID } = {}) =>
    networkAPIAction(PerformanceIndicatorDayDataApi, 'performanceIndicatorDayDataMergeAllPut', NetworkActionPrefix.MERGE_ALL_PERFORMANCE_INDICATOR_DAY_DATA_PREFIX, { entities, rollOverLevels, aggregationLevelID }, entities, rollOverLevels, { aggregationLevelID });

export const mergeAllPerformanceIndicatorWeekData = (entities, rollOverLevels = false, { aggregationLevelID } = {}) =>
    networkAPIAction(PerformanceIndicatorWeekDataApi, 'performanceIndicatorWeekDataMergeAllPut', NetworkActionPrefix.MERGE_ALL_PERFORMANCE_INDICATOR_WEEK_DATA_PREFIX, { entities, rollOverLevels, aggregationLevelID }, entities, rollOverLevels, { aggregationLevelID });

export const mergeAllPerformanceIndicatorMonthData = (entities, rollOverLevels = false, { aggregationLevelID } = {}) =>
    networkAPIAction(PerformanceIndicatorMonthDataApi, 'performanceIndicatorMonthDataMergeAllPut', NetworkActionPrefix.MERGE_ALL_PERFORMANCE_INDICATOR_MONTH_DATA_PREFIX, { entities, rollOverLevels, aggregationLevelID }, entities, rollOverLevels, { aggregationLevelID });

export const mergeAllPerformanceIndicatorQuarterData = (entities, rollOverLevels = false, { aggregationLevelID } = {}) =>
    networkAPIAction(PerformanceIndicatorQuarterDataApi, 'performanceIndicatorQuarterDataMergeAllPut', NetworkActionPrefix.MERGE_ALL_PERFORMANCE_INDICATOR_QUARTER_DATA_PREFIX, { entities, rollOverLevels, aggregationLevelID }, entities, rollOverLevels, { aggregationLevelID });

export const mergeAllPerformanceIndicatorYearData = (entities, rollOverLevels = false, { aggregationLevelID } = {}) =>
    networkAPIAction(PerformanceIndicatorYearDataApi, 'performanceIndicatorYearDataMergeAllPut', NetworkActionPrefix.MERGE_ALL_PERFORMANCE_INDICATOR_YEAR_DATA_PREFIX, { entities, rollOverLevels, aggregationLevelID }, entities, rollOverLevels, { aggregationLevelID });

export const mergeAllPerformanceIndicatorData = (periodID, entities, rollOverLevels = false, optionalParams) => {
    switch (periodID) {
        case PeriodType.DAY:
            return mergeAllPerformanceIndicatorDayData(entities, rollOverLevels, optionalParams);

        case PeriodType.WEEK:
            return mergeAllPerformanceIndicatorWeekData(entities, rollOverLevels, optionalParams);

        case PeriodType.MONTH:
            return mergeAllPerformanceIndicatorMonthData(entities, rollOverLevels, optionalParams);

        case PeriodType.QUARTER:
            return mergeAllPerformanceIndicatorQuarterData(entities, rollOverLevels, optionalParams);

        case PeriodType.YEAR:
            return mergeAllPerformanceIndicatorYearData(entities, rollOverLevels, optionalParams);

        default:
            return assertNever(periodID, `Unknown PeriodID: ${periodID}`);
    }
};

export const clearPerformanceIndicatorData = templates =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorClearDataPut', NetworkActionPrefix.CLEAR_PERFORMANCE_INDICATOR_DATA_PREFIX, { templates }, templates);

export const copyPerformanceIndicatorData = mappings =>
    networkAPIAction(PerformanceIndicatorApi, 'performanceIndicatorCopyDataPut', NetworkActionPrefix.COPY_PERFORMANCE_INDICATOR_DATA_PREFIX, { mappings }, mappings);

export const loadAllPerformanceIndicatorFormulaElementTypes = () => networkAPIAction(PerformanceIndicatorFormulaElementTypeApi, 'performanceIndicatorFormulaElementTypeLoadAllGet', NetworkActionPrefix.LOAD_ALL_PERFORMANCE_INDICATOR_FORMULA_ELEMENT_TYPES_PREFIX, {});

export const mergeFormulaItems = (formulaItems, indicatorID, useDynamicFilter, calculate = true) =>
    networkAPIAction(
        PerformanceIndicatorFormulaApi,
        'performanceIndicatorFormulaMergeFormulaItemsPut',
        NetworkActionPrefix.MERGE_FORMULA_ITEMS_PREFIX,
        { formulaItems, indicatorID, useDynamicFilter, calculate },
        formulaItems,
        indicatorID,
        useDynamicFilter,
        calculate
    );
